import noop from 'lodash/noop'
import React, { FC } from 'react'
import styled from 'styled-components'

import AngleRightIcon from '@Assets/SVG/AngleRight'
import { CategoryIcon, SVGIcon } from '@Components/Icons'

interface CategoryItemProps {
  id: string
  onTopCategoryClick?: () => void
  title: string
}

const StyledRightSide = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 2;
  min-height: 60px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyLighter};
`

const StyledCategoryItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 60px;
  cursor: pointer;

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.greyLighter};

    & > ${StyledRightSide} {
      border-bottom: none;
    }
  }
`

const StyledIcon = styled.div`
  flex-shrink: 0;
  margin: 0 20px;
  min-width: 20px;
`

const StyledTitle = styled.span`
  display: flex;
  align-items: center;
  flex-grow: 2;
  padding: 10px 0;
  line-height: 1.3;
`

const StyledArrow = styled.div`
  margin-right: 20px;
`

export const CategoryItem: FC<CategoryItemProps> = (
  {
    id,
    onTopCategoryClick = noop,
    title,
  }: CategoryItemProps,
) => (
  <StyledCategoryItem onClick={() => onTopCategoryClick()}>
    <StyledIcon>
      <CategoryIcon categoryID={id} />
    </StyledIcon>
    <StyledRightSide>
      <StyledTitle>{title}</StyledTitle>
      <StyledArrow>
        <SVGIcon icon={AngleRightIcon} size="14px" />
      </StyledArrow>
    </StyledRightSide>
  </StyledCategoryItem>
)
